module.exports = __webpack_public_path__ + "img/Frame-47.7e84d049.svg";